export default __webpack_public_path__ + "static/media/ak.1e6a773f.png";